import { DependenciesInjection } from "app/di/DependencyInjection";
import { CdnConfigurationImpl } from "../data/CdnConfigurationImpl";
import { ICdnConfigurationRepository } from "../domain/repositories/ICdnConfigurationRepository";
import { CdnConfigurationUseCase } from "../domain/useCases/CdnConfigurationUseCase";
import { CdnConfigurationViewModel } from "../presentation/viewModel/CdnConfigurationViewModel";
import { CdnConfigToken } from "./CdnConfigToken";

export class CdnConfigInjection {
  static initInjection() {
    DependenciesInjection.register<ICdnConfigurationRepository>(
      CdnConfigToken.ICdnConfigurationRepository,
      CdnConfigurationImpl,
      "otherRepo",
    );
    DependenciesInjection.register<CdnConfigurationUseCase>(
      CdnConfigToken.CdnConfigurationUseCase,
      CdnConfigurationUseCase,
      "otherRepo",
    );
    DependenciesInjection.register<CdnConfigurationViewModel>(
      CdnConfigToken.CdnConfigurationViewModel,
      CdnConfigurationViewModel,
      "viewModel",
    );
  }

  static getRepo() {
    return DependenciesInjection.getRepo<ICdnConfigurationRepository>(
      CdnConfigToken.ICdnConfigurationRepository,
    );
  }

  static getUseCase() {
    return DependenciesInjection.getRepo<CdnConfigurationUseCase>(
      CdnConfigToken.CdnConfigurationUseCase,
    );
  }

  static getViewModel() {
    return DependenciesInjection.getRepo<CdnConfigurationViewModel>(
      CdnConfigToken.CdnConfigurationViewModel,
    );
  }
}
